export default __webpack_public_path__ + "b7e27f384ae6596145aaf19cd7bdff2c.svg";